import {Exclude} from "class-transformer";
import {IdTextStateModel} from "common-shared";

export class TableColumn<T> {
  constructor(init?: Partial<TableColumn<T>>) {
    Object.assign(this, init);
  }
  Identifier: T;
  Name: string;
  Code: string;
  @Exclude({ toPlainOnly: true })
  Width: number;
  IsSelected: boolean;
  Values?: IdTextStateModel[];
}

export enum IntegratedMasterListColumns {
  Target ,
  ProcessSelector,
  ProcessSelectorValidCondition,
  ProcessSelectorSpecs,
  ProcessNumber,
  Process,
  ProcessValidCondition,
  OperationSpecs,
  TaskSelector,
  TaskSelectorValidCondition,
  TaskSelectorSpecs,
  Code,
  Type,
  Item,
  PrevNumber,
  Setup,
  Production,
  Teardown,
  InstructionValidCondition,
  Valid,
  Yield,
  InstructionSpecs,
  TimeConstraintMethodClv,
  TimeConstraintMin,
  TimeConstraintMax,
  Customer
}

export enum SpecLinesEditColumns {
  Formula = 0,
  Constraints = 1,
  Alias = 2,
  Sequence = 3,
  Group = 4,
  Origin = 5,
  Mandatory = 6,
  Priority= 8,
  AliasFormula = 9,
  Source = 10,
  Message = 11,
  MessageFormula= 12,
}


